import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { fetchBillingPlans } from 'redux/billing/actions';

import { Link } from 'react-router-dom';

import PlanModeSelector from 'components/dashboard/billing-content/PlanModeSelector';
import CommonMessage from 'components/common/CommonMessage';

import './BillingPlansList.css';

class BillingPlansList extends Component {
  static propTypes = {
    fetchBillingPlans: PropTypes.func.isRequired,
    me: PropTypes.object,
    countries: PropTypes.arrayOf(PropTypes.shape),
    billingPlans: PropTypes.arrayOf(PropTypes.shape),
    billingPlansError: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    countries: null,
    billingPlans: null,
    billingPlansError: null,
  };

  state = {
    planMode: 'month',
  };

  componentDidMount() {
    if (!this.props.billingPlans) {
      this.props.fetchBillingPlans();
    }
  }

  setPlanMode = planMode => this.setState({ planMode });

  renderBillingPlansError = () => (
    <CommonMessage
      error
      errors={this.props.billingPlansError}
    />
  );

  renderStarterCard = () => (
    <Translation>
      {(t) => (
        <div className="plan-card starter">
          <div className="blockrow">
            <div className="plan-header">
              <div className="plan-name">{t("STARTER")}</div>
            </div>
            <div className="cost">
              <span>{t("Free")}</span> / {t("forever")}
            </div>
          </div>

          <div className="save-value" />

          <div className="features-list">
            <div className="feature-item">
              <div className="icon" />
              <div className="text">{t("Unlimited Links")}</div>
            </div>
            <div className="feature-item">
              <div className="icon" />
              <div className="text">{t("Link Analytics")}</div>
            </div>
            <div className="feature-item">
              <div className="icon" />
              <div className="text">{t("Instant Checkout")}</div>
            </div>
            <div className="feature-item">
              <div className="icon" />
              <div className="text">{t("Ecommerce Store & Unlimited Products")}</div>
            </div>
            <div className="feature-item">
              <div className="icon" />
              <div className="text">{t("Lead Generation")}</div>
            </div>
            <div className="feature-item">
              <div className="icon" />
              <div className="text">
                {t("Social Media Reports")} ( <strong>{t("1 report / month")} </strong>)
              </div>
            </div>
          </div>

          <div className="buttons-block">
            {this.props.me &&
              this.props.me.subscription &&
              this.props.me.subscription.billing_plan &&
              this.props.me.subscription.billing_plan.title === 'Starter' &&
              <div className="plan-button current">
                {t("Your current plan")}
              </div>
            }
          </div>
        </div>
      )}
    </Translation>
  );

  renderProCard = () => {
    const { me } = this.props;
    const proPlan = this.props.billingPlans &&
      this.props.billingPlans.filter(plan => plan.title === 'Pro')[0];

    return (
      <Translation>
        {(t) => (
          <div className="plan-card pro">
            <div className="buttons-block btn-hide">
              {(this.props.me &&
                this.props.me.subscription &&
                this.props.me.subscription.billing_plan &&
                this.props.me.subscription.billing_plan.title !== 'Starter') ?
                <div className="current-container">
                  <div className="plan-button current">
                    {t("Your current plan")}
                  </div>
                  <Link
                    className="update-billing"
                    to="/billing/subscription"
                  >
                    {t("Update Billing")}
                  </Link>
                </div>
                :
                <Link
                  className="plan-button get-pro"
                  to="/billing/subscription"
                >
                  {t("Get PRO")}
                </Link>
              }
            </div>

            <div className="plan-header">
              <div className="plan-name">{t("PRO")}</div>
              <PlanModeSelector
                initialMode={me.subscription.billing_plan.interval}
                setPlanMode={this.setPlanMode}
              />
            </div>
            <div className="cost">
              {proPlan &&
                <Fragment>
                  {this.state.planMode === 'year' ?
                    <div><span>${proPlan.annual_price} USD</span> / {t("year")}</div>
                    :
                    <div><span>${proPlan.monthly_price} USD</span> / {t("month")}</div>
                  }
                </Fragment>
              }
            </div>
            <div className="save-value">
              {proPlan &&
                <Fragment>
                  {this.state.planMode === 'year' ?
                    <div>
                      <strike>${proPlan.monthly_price}</strike>&nbsp;
                      ${proPlan.monthly_price_annual} / {t("month")}:
                      {t("save")} {proPlan.annual_price_discount}% {t("on the yearly plan")}
                    </div>
                    :
                    <div>{t("Save")} {proPlan.annual_price_discount}% {t("on the yearly plan")}</div>
                  }
                </Fragment>
              }
            </div>

            <div className="rocket" />

            <div className="features-list">
              <div className="feature-item">
                <div className="icon" />
                <div className="text">{t("All features of")} <strong>{t("STARTER")}</strong></div>
              </div>
              <div className="feature-item">
                <div className="icon" />
                <div className="text"><strong>PRO</strong> {t("Link Analytics")}</div>
              </div>
              <div className="feature-item">
                <div className="icon" />
                <div className="text"><strong>PRO</strong> {t("Themes")}</div>
              </div>
              <div className="feature-item">
                <div className="icon" />
                <div className="text"><strong>PRO</strong> {t("Avatars")}</div>
              </div>
              <div className="feature-item">
                <div className="icon" />
                <div className="text"><strong>PRO</strong> {t("Icons")}</div>
              </div>
              <div className="feature-item">
                <div className="icon" />
                <div className="text"><strong>PRO</strong> {t("Custom Branding")}</div>
              </div>
              <div className="feature-item">
                <div className="icon" />
                <div className="text"><strong>PRO</strong> {t("Whitelabel (coming soon)")}</div>
              </div>
              <div className="feature-item">
                <div className="icon" />
                <div className="text"><strong>PRO</strong> {t("Support")}</div>
              </div>
              <div className="feature-item social-media">
                <div className="icon" />
                <div className="text">
                  {t("Social Media Reports")} ( <strong>{t("3 reports / month")} </strong>)
                </div>
              </div>
            </div>

            <div className="buttons-block">
              {(this.props.me &&
                this.props.me.subscription &&
                this.props.me.subscription.billing_plan &&
                this.props.me.subscription.billing_plan.title !== 'Starter') ?
                <div className="current-container">
                  <div className="plan-button current">
                    {t("Your current plan")}
                  </div>
                  <Link
                    className="update-billing"
                    to="/billing/subscription"
                  >
                    {t("Update Billing")}
                  </Link>
                </div>
                :
                <Link
                  className="plan-button get-pro"
                  to="/billing/subscription"
                >
                  {t("Get PRO")}
                </Link>
              }
            </div>
          </div>
        )}
      </Translation>
    );
  };

  render() {
    const { me, billingPlansError } = this.props;
    if (!me || !me.subscription) { return null; }
    if (billingPlansError) { return this.renderBillingPlansError(); }

    return (
      <div className="billing-plans-list__component">
        <div className="plans-wrapper">
          {this.renderStarterCard()}
          {this.renderProCard()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    billingPlans: state.billingReducer.billingPlans,
    billingPlansError: state.billingReducer.billingPlansError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchBillingPlans,
  },
)(BillingPlansList);
